import { render, staticRenderFns } from "./ContactDuplicatesListHeader.vue?vue&type=template&id=750c698e"
import script from "./ContactDuplicatesListHeader.vue?vue&type=script&lang=js"
export * from "./ContactDuplicatesListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports